module.exports = __webpack_public_path__ + "static/media/takeaway-disabled.c7b1cd28.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/bottomNavigation/takeaway-disabled.svg
// module id = 2255
// module chunks = 0